import escapeRegExp from "lodash/escapeRegExp";
import { replaceValues } from "../components/utils";

export function getMailDomain(mail) {
  if (!mail) return null;
  const pos = mail.indexOf("@");
  if (pos === -1) return null;
  return `"${mail
    .slice(pos + 1)
    .trim()
    .toLowerCase()}"`;
}

export function validateEmail(email, domainRegex, strings = {}) {
  const emailDomain = getMailDomain(email) || "";

  const {
    invalidEmail = "L'adesse mail est invalide",
    invalidDomain = `Le nom de domaine {emailDomain} n'est pas autorisé`,
  } = strings;
  // eslint-disable-next-line no-useless-escape
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const isValidEmail = re.test(String(email).toLowerCase());
  const isValidDomain = isEmailDomainCompliant(email, domainRegex);
  console.log("isValidDomain", isValidDomain);
  const errors = [
    !isValidEmail && invalidEmail,
    !isValidDomain && replaceValues(invalidDomain, { emailDomain }),
  ].filter((e) => e);
  return { isValid: isValidEmail && isValidDomain, errors };
}

export function isEmailDomainCompliant(email, domainRegex) {
  if (!email) return false;
  if (!domainRegex) return true;
  const isMatching = new RegExp(domainRegex, "i").test(email);
  return isMatching;
}

export function getEmailDomainRegex({ whitelist = [], blacklist = [] }) {
  if (!whitelist.length && !blacklist.length) return;
  return whitelist.length
    ? `^.*@(${whitelist.map((d) => `(${escapeRegExp(d)})`).join("|")})$`
    : `^.*@(${blacklist.map((d) => `(?!${escapeRegExp(d)})`).join("")}.)*$`;
}